import { callNativeWithoutResult, getRequestHeaders, openInApp } from '@ruguoapp/jike-js-sdk'
import router from './router'
import buildHost from './request/buildHost'
import { JIKE_WEB_HOST } from './request/host'
import { normalizeRedirectURL } from './redirectURL'

interface AppAuthTokens {
	accessToken: string
	deviceId: string
}

function getHeaderValue(headers: Awaited<ReturnType<typeof getRequestHeaders>>, key: string) {
	const value = headers?.[key]

	return typeof value === 'string' ? value : null
}

export function buildAppAuthConfirmationURL(redirectURL: string) {
	return new URL(
		router.buildLocation({
			to: '/login/app-auth/confirmation',
			search: {
				redirectURL: normalizeRedirectURL(redirectURL),
			},
		}).href,
		buildHost(JIKE_WEB_HOST)
	).toString()
}

export function openAppAuthConfirmationPage(redirectURL: string) {
	const confirmationURL = buildAppAuthConfirmationURL(redirectURL)
	openInApp(confirmationURL, {
		displayHeader: true,
		displayFooter: false,
		displayHeaderShareIcon: false,
	})
}

export async function getAppAuthTokens() {
	const headers = await getRequestHeaders()
	const accessToken = getHeaderValue(headers, 'x-jike-access-token')
	const deviceId = getHeaderValue(headers, 'x-jike-device-id')

	if (!accessToken || !deviceId) {
		throw new Error('No valid app auth tokens')
	}

	return {
		accessToken,
		deviceId,
	} satisfies AppAuthTokens
}

export function buildAppAuthCompleteURL({
	accessToken,
	deviceId,
	redirectURL,
}: AppAuthTokens & {
	redirectURL: string
}) {
	const url = new URL(
		router.buildLocation({
			to: '/login/app-auth/complete',
		}).href,
		buildHost(JIKE_WEB_HOST)
	)
	url.hash = new URLSearchParams({
		accessToken,
		deviceId,
		redirectURL: normalizeRedirectURL(redirectURL),
	}).toString()

	return url.toString()
}

export function openInExternalBrowser(url: string) {
	void callNativeWithoutResult('rg_open_webview', {
		url,
		external: true,
	})
}
